export const localeToRegionIdMap = {
  'vi': 'VN',
  'hk': 'HK',
  'tw': 'TWN',
  'id': 'ID',
  'th': 'TH',
  'sg': 'SG',
  'my': 'MY',
  'ph': 'PH',
  'in': 'IN',
}

export const uniteTenementId = '99870011' // 海外枪战的租户id

export const errorCodeMap = {
  3001: 'payment.validateUser.userNotFound',
  3004: 'payment.maintainTip',
}